import { Box, Skeleton, Stack } from '@mui/material';

/**
 * Réserve la hauteur d’une page liste (filtres + grille) pour éviter le layout shift.
 */
export default function ListPageSkeleton({ filterSlots = 2, rows = 8 }) {
  return (
    <Stack spacing={2} sx={{ width: '100%' }} aria-busy="true" aria-label="Chargement">
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
        {Array.from({ length: filterSlots }).map((_, i) => (
          <Skeleton key={`flt-${i}`} variant="rounded" height={40} sx={{ flex: 1, maxWidth: { md: 280 }, borderRadius: 1 }} />
        ))}
      </Stack>
      <Box
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          overflow: 'hidden',
          bgcolor: 'background.paper',
        }}
      >
        <Box sx={{ px: 2, py: 1.25, borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'action.hover' }}>
          <Stack direction="row" spacing={2}>
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton key={`hdr-${i}`} variant="text" width={i === 4 ? 48 : 100} height={20} />
            ))}
          </Stack>
        </Box>
        {Array.from({ length: rows }).map((_, i) => (
          <Stack
            key={`row-${i}`}
            direction="row"
            alignItems="center"
            spacing={2}
            sx={{
              px: 2,
              py: 1.5,
              borderBottom: '1px solid',
              borderColor: 'divider',
              minHeight: 52,
            }}
          >
            <Skeleton variant="text" width="22%" height={22} />
            <Skeleton variant="text" width="28%" height={22} />
            <Skeleton variant="text" width="18%" height={22} />
            <Skeleton variant="rounded" width={72} height={28} />
            <Box sx={{ flex: 1 }} />
            <Skeleton variant="rounded" width={40} height={36} />
          </Stack>
        ))}
      </Box>
    </Stack>
  );
}
